module.exports = __webpack_public_path__ + "static/media/libro16.ce041497.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro16.png
// module id = 364
// module chunks = 0